import { Plus } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const AddMemberDialog = ({ children, isDisabled = false }: React.PropsWithChildren<{ isDisabled?: boolean }>) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="sm" disabled={isDisabled}>
          <Plus /> Add members
        </Button>
      </DialogTrigger>
      <DialogContent className="w-230 sm:max-w-[calc(100vw-48px)] max-h-[min(640px,100dvh-48px)] grid-rows-[auto_1fr_auto] max-sm:h-dvh max-sm:w-full max-sm:max-h-none max-sm:max-w-none max-sm:rounded-none max-sm:border-0">
        <DialogHeader>
          <DialogTitle>Add members to this escrow</DialogTitle>
          <DialogDescription>
            By default, the escrow creator and account owner have administrative permissions. All other team members
            must be granted access to the escrow for them to contribute. If a team member isn’t listed, first add them
            to the organization.
          </DialogDescription>
        </DialogHeader>
        <div className="max-sm:min-h-0 max-sm:overflow-y-auto">{children}</div>
        <DialogFooter className="shrink-0">
          <DialogClose asChild>
            <Button>Done</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddMemberDialog;
